import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from '@mui/material';
import {
  Inventory as InventoryIcon,
  ShoppingCart as OrderIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import { auth } from '../utils/auth';

const SubUserDashboard = () => {
  const permissions = auth.getUser()?.permissions || {};

  const permissionsList = [
    { 
      name: 'Productos', 
      icon: <InventoryIcon />,
      permissions: [
        { key: 'canCreateProducts', label: 'Crear productos' },
        { key: 'canEditProducts', label: 'Editar productos' },
        { key: 'canDeleteProducts', label: 'Eliminar productos' }
      ]
    },
    {
      name: 'Pedidos',
      icon: <OrderIcon />,
      permissions: [
        { key: 'canViewOrders', label: 'Ver pedidos' },
        { key: 'canProcessOrders', label: 'Procesar pedidos' }
      ]
    },
    {
      name: 'Análisis',
      icon: <AnalyticsIcon />,
      permissions: [
        { key: 'canViewAnalytics', label: 'Ver análisis' }
      ]
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Panel de Control - Sub-usuario
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Tus Permisos
            </Typography>
            <List>
              {permissionsList.map((section) => (
                <React.Fragment key={section.name}>
                  <ListItem>
                    <ListItemIcon>
                      {section.icon}
                    </ListItemIcon>
                    <ListItemText 
                      primary={section.name}
                      secondary={
                        <Box component="span" sx={{ display: 'block', mt: 1 }}>
                          {section.permissions.map(({ key, label }) => (
                            <Typography
                              key={key}
                              variant="body2"
                              color={permissions[key] ? 'success.main' : 'error.main'}
                              sx={{ display: 'block' }}
                            >
                              • {label}: {permissions[key] ? 'Permitido' : 'No permitido'}
                            </Typography>
                          ))}
                        </Box>
                      }
                    />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Información de Usuario
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Usuario"
                  secondary={auth.getUser()?.name}
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Email"
                  secondary={auth.getUser()?.email}
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Último acceso"
                  secondary={new Date(auth.getUser()?.lastLogin).toLocaleString()}
                />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubUserDashboard; 